import type { useAuth0 } from "@auth0/auth0-react";
import ky from "ky";

let getAccessToken: ReturnType<typeof useAuth0>["getAccessTokenSilently"];

export const configureAuth = (fn: ReturnType<typeof useAuth0>["getAccessTokenSilently"]) => {
  getAccessToken = fn;
};

export const api = ky.create({
  hooks: {
    beforeRequest: [
      async ({ request }) => {
        const accessToken = await getAccessToken();
        request.headers.set("Authorization", `Bearer ${accessToken}`);
      },
    ],
  },
});
